interface PaginationControlsProps {
  total: number;
  limit: number;
  offset: number;
  onPageChange: (offset: number) => void;
}

export default function PaginationControls({
  total,
  limit,
  offset,
  onPageChange,
}: PaginationControlsProps) {
  const page = Math.floor(offset / limit) + 1;
  const totalPages = Math.max(1, Math.ceil(total / limit));
  const prevOffset = Math.max(0, offset - limit);
  const nextOffset = offset + limit;

  return (
    <div className="pagination-controls">
      <button disabled={offset === 0} onClick={() => onPageChange(prevOffset)}>
        이전
      </button>
      <span>
        {page} / {totalPages} 페이지 · 총 {total}건
      </span>
      <button disabled={nextOffset >= total} onClick={() => onPageChange(nextOffset)}>
        다음
      </button>
    </div>
  );
}
